import * as React from 'react';
import * as I18n from 'i18n-js';

import { IAdminAccommodationReason } from './refund_request';

interface IProps {
  adminAccommodationReason: IAdminAccommodationReason;
  onAdminAccommodationReasonChange: (event: any) => void;
}

export default function AdminAccommodationReasonDropdown(props: IProps) {
  const {
    adminAccommodationReason,
    onAdminAccommodationReasonChange,
  } = props;

  return (
    <div className="form-group scaling-mtb-2 admin_accommodation_reason">
      <div className="form-group__header">
        <label
          className="form-group__label-text"
          htmlFor="order_refund_request_admin_accommodation_reason[admin_accommodation_reason]"
        >
          {I18n.t('discovery.dashboard.refundRequests.admin.accommodationReason.title')}
        </label>
        <div className="form-group__tag">
          {I18n.t('discovery.dashboard.refundRequests.required')}
        </div>
      </div>
      <div className="styled-dropdown">
        <select
          name="order_refund_request[admin_accommodation_reason]"
          id="order_refund_request_admin_accommodation_reason"
          required
          value={adminAccommodationReason}
          onChange={onAdminAccommodationReasonChange}
        >
          {PlaceHolderOption()}
          {AccommodationReasonOptions()}
        </select>
      </div>
    </div>
  );
}

function PlaceHolderOption() {
  return (
    <option value="" key="placeholder">
      {I18n.t('discovery.dashboard.refundRequests.selectOne')}
    </option>
  );
}

function AccommodationReasonOptions() {
  const adminAccommodationReasons = Object.keys(IAdminAccommodationReason).map(
    reason => IAdminAccommodationReason[reason],
  );

  return (
    adminAccommodationReasons.map(reason => AccommodationReasonOption(reason))
  );
}

function AccommodationReasonOption(reason: IAdminAccommodationReason) {
  const displayName = I18n.t(
    `discovery.dashboard.refundRequests.admin.accommodationReason.displayNames.${reason}`,
  );

  return (
    <option key={reason} value={reason}>{displayName}</option>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/refund_requests/admin_accommodation_reason_dropdown.tsx